import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import SortByDropdown from 'Components/Utility/SortBy/SortByDropdown';
import { indexAlgoliaName } from 'Redux/ducks/algolia-calls';
import sortByMessages from 'Components/Utility/SortBy/SortByMessages';

const WishlistSortDropDown = ({
  sort,
  onSortChange,
  intl: { formatMessage },
}) => {
  const indexName = indexAlgoliaName;

  const sortByOptions = [
    { name: formatMessage(sortByMessages.topSellers), value: indexName },
    { name: formatMessage(sortByMessages.priceLowHigh), value: `${indexName}_price_asc` },
    { name: formatMessage(sortByMessages.priceHighLow), value: `${indexName}_price_desc` },
    { name: formatMessage(sortByMessages.alphabetical), value: `${indexName}_name` },
    { name: formatMessage(sortByMessages.topDiscount), value: `${indexName}_discount` },
    { name: formatMessage(sortByMessages.latestDeals), value: `${indexName}_latest_deals` },
    { name: formatMessage(sortByMessages.endingSoon), value: `${indexName}_ending_soon` },
    { name: formatMessage(sortByMessages.mostWanted), value: `${indexName}_most_wanted` },
    { name: formatMessage(sortByMessages.releaseDate), value: `${indexName}_release_date_desc` },
    { name: formatMessage(sortByMessages.topRated), value: `${indexName}_top_rated` },
  ];

  return (
    <SortByDropdown
      options={sortByOptions}
      value={sort}
      onChange={onSortChange}
    />
  );
};

WishlistSortDropDown.propTypes = {
  sort: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
};

export default injectIntl(WishlistSortDropDown);
